import { useState, useEffect } from 'react';
import './Navbar.css';
import content from '../data/content.json';
import { useTheme } from '../contexts/ThemeContext';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;

      // Muda o fundo quando passar do banner (100vh)
      setIsScrolled(scrollPosition > viewportHeight);
    };

    // Chama uma vez ao carregar
    handleScroll();

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : 'navbar-transparent'}`}>
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-brand" onClick={scrollToTop}>
            {content.navbar.brandName}
          </div>

          <div className="navbar-right">
            <ul className="navbar-links desktop-only">
              {content.navbar.links.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>

            <a href="#crencas" className="contact-button desktop-only">
              Contato
            </a>

            <button
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label="Alternar tema"
              title={theme === 'light' ? 'Ativar tema escuro' : 'Ativar tema claro'}
            >
              {theme === 'light' ? '🌙' : '☀️'}
            </button>

            <button
              className={`burger-menu ${isMobileMenuOpen ? 'open' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-links">
          {content.navbar.links.map((link, index) => (
            <li key={index}>
              <a href={link.href} onClick={closeMobileMenu}>{link.label}</a>
            </li>
          ))}
          <li>
            <a href="#crencas" className="mobile-contact-button" onClick={closeMobileMenu}>
              Contato
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
